import { RouterProvider, createRouter } from '@tanstack/react-router';
import * as React from 'react';
import { createRoot } from 'react-dom/client';

import { captureCheckoutTransactionFromUrl } from '@/lib/paddle-transaction';
import { queryClient } from '@/lib/trpc/shared';

import { routeTree } from './routeTree.gen';

import './styles/fonts.css';
import '@/styles/globals.css';

captureCheckoutTransactionFromUrl(window.location.search);

const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: 'intent',
  scrollRestoration: true,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root introuvable');
}

createRoot(rootElement).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
